import type { Resource } from '../../';
export const footer_bottomLink: Resource = {"default":"FLY FOR 30 GUARANTEE | FREE SHIPPING, FREE RETURNS"};
